import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
var Puntal = function Puntal() {
  _classCallCheck(this, Puntal);
};
export { Puntal as default };